<template>
  <MainLayout />
</template>

<script>
import MainLayout from '@/layouts/MainLayout.vue';
import { useAuthStore } from '@/stores/authStore'; // Import the auth store

export default {
  name: 'App',
  components: {
    MainLayout
  },
  mounted() {
    const auth = useAuthStore();
    auth.initializeAuth();
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>